import { createCalendarPickerOptions } from '../actions/privateActions';
import { CalendarOption } from '../store/schema/CalendarChannelPickerInterfaces';
import { getStore } from '../store/store';
import formatSelectedOptionName from '../utils/formatSelectedOptionName';
import getEmailAddressForAllAccounts from '../utils/getEmailAddressForAllAccounts';
import { getCalendarIdByFolderId } from 'owa-calendar-cache';
import getCalendarsForCalendarPicker from 'owa-calendar-forms-common/lib/utils/getCalendarsForCalendarPicker';
import { getUserMailboxInfo } from 'owa-client-ids';
import { orchestrator } from 'satcheljs';
import {
    onOptionSelected,
    getCompositePickerOptionsForAccount,
    addPickerSections,
    updatePickerSections,
    PickerOptionsSection,
    removePickerOption,
} from 'owa-calendar-composite-picker';

orchestrator(createCalendarPickerOptions, actionMessage => {
    const { event } = actionMessage;
    const primaryAccount = getUserMailboxInfo().userIdentity;
    const accounts = getEmailAddressForAllAccounts();
    const selectedCalendarId = getCalendarIdByFolderId(event.ParentFolderId.Id);

    let index = 0;

    for (let account of accounts) {
        const isPrimaryAccount = primaryAccount === account;
        const calendars = getCalendarsForCalendarPicker(event, account);
        const subOptions: CalendarOption[] = [];

        for (let cal of calendars) {
            const isSelected = cal.id.id == selectedCalendarId?.id;
            const subOption: CalendarOption = {
                id: cal.id.id,
                displayName: cal.displayName || '',
                calendar: cal,
                account: account,
                isShown: true,
                index: index,
            };
            subOptions.push(subOption);
            index++;

            if (isSelected) {
                onOptionSelected(
                    getStore(),
                    option => formatSelectedOptionName(event, option),
                    subOption
                );
            }
        }

        const optionsForAccount = getCompositePickerOptionsForAccount(getStore(), account);

        if (optionsForAccount) {
            updatePickerSections(optionsForAccount, subOptions);

            // If the account doesn't have any options, then remove the account from the store
            if (
                optionsForAccount.leafOptions.length === 0 &&
                optionsForAccount.parentOptions.length === 0
            ) {
                removePickerOption(getStore(), optionsForAccount);
            }
        } else if (subOptions.length > 0) {
            const newOption: PickerOptionsSection = {
                account: account,
                isPrimaryAccount: isPrimaryAccount,
                leafOptions: subOptions,
                parentOptions: [],
            };

            addPickerSections(getStore(), newOption);
        }
    }
});
